import * as React from "react"

import * as styles from "./index.module.scss"

interface Props {
  children?: React.ReactNode
  className?: string
}

function InputError({ className = "", ...otherProps }: Props) {
  return (
    <span
      className={`${styles.error} ${className}`}
      role="alert"
      {...otherProps}
    />
  )
}

InputError.defaultProps = {
  className: "",
}

export default InputError
